/*eslint-disable */
import { parseToDom, isNullOrEmptyOrUndefined } from '../../../common/utils';

const clsIdentifier = {
   articleContent: 'artlicle-list-container',
   controlbarBottom: 'controlbar__bottom'
};

export function respTransformer(respStr) {
   const returnResp = {};
   let respHtml;
   if (respStr.data) {
       respHtml = parseToDom(respStr.data);
   }
   else {
       respHtml = parseToDom(respStr);
   }
   Object.keys(clsIdentifier).forEach(key => {
       const respFragment = respHtml.querySelector(`.${clsIdentifier[key]}`);
       returnResp[key] = isNullOrEmptyOrUndefined(respFragment) ? respFragment.innerHTML : '';
   });
   return returnResp;
}



// WEBPACK FOOTER //
// /src/pages/main/helpers/resUtil.js